import { UserRole } from "@/store/useAuthStore";

export const ROLE_PERMISSIONS: Record<UserRole, string[]> = {
    admin: ['*'],
    management: ['orders', 'create_order', 'edit_order', 'item_sales_report'],
    preparing: ['preparing_pieces'],
    pieces_auditor: ['pieces_audit'],
    packaging: [
        'orders',
        'create_order',
        'edit_order',
        'ready_orders',
        'order_images',
        'partial_order_pieces',
        'preparing_pieces',
        'shipping_zones_management',
        'activities',
        'pieces_audit'
    ],
}
export const hasPermission = (role: UserRole | null, page: string): boolean => {
    if (!role) return false;
    const parms = ROLE_PERMISSIONS[role] ?? [];
    return parms.includes('*') || parms.includes(page);
}